import { render, staticRenderFns } from "./BackupClientRef.vue?vue&type=template&id=ffd92824&scoped=true&"
import script from "./BackupClientRef.vue?vue&type=script&lang=js&"
export * from "./BackupClientRef.vue?vue&type=script&lang=js&"
import style0 from "./BackupClientRef.vue?vue&type=style&index=0&id=ffd92824&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd92824",
  null
  
)

export default component.exports